import {useLayoutQuery} from '../../page-data/loaders/use-layout-query'
import {PullRequestState} from '../../types'
import type {DefaultError, UseMutationResult} from '@github-ui/react-query'

type StateChangeActionName = 'mark-ready' | 'convert-to-draft' | 'close' | 'reopen'

/** Returns array of available actions in consistent order. */
export function useAvailableStateChangeActions({
  markReadyForReviewMutation,
  convertToDraftMutation,
  closeMutation,
  reopenMutation,
}: {
  markReadyForReviewMutation: UseMutationResult<void, DefaultError, void>
  convertToDraftMutation: UseMutationResult<void, DefaultError, void>
  closeMutation: UseMutationResult<void, DefaultError, void>
  reopenMutation: UseMutationResult<void, DefaultError, void>
}): StateChangeActionName[] {
  const {
    data: {pullRequest, user},
  } = useLayoutQuery()

  // Keep each item visible when the corresponding mutation is pending, so optimistic updates don't immediately hide it
  const actions: StateChangeActionName[] = []

  if (
    (pullRequest.state === PullRequestState.Draft && user?.canMarkReadyForReview) ||
    markReadyForReviewMutation.isPending
  )
    actions.push('mark-ready')

  if ((pullRequest.state === PullRequestState.Open && user?.canConvertToDraft) || convertToDraftMutation.isPending)
    actions.push('convert-to-draft')

  if (
    ((pullRequest.state === PullRequestState.Open || pullRequest.state === PullRequestState.Draft) && user?.canClose) ||
    closeMutation.isPending
  )
    actions.push('close')

  if ((pullRequest.state === PullRequestState.Closed && user?.canReopen) || reopenMutation.isPending)
    actions.push('reopen')

  return actions
}
